// HyperEVM block gas limits
// Small blocks: ~1 second confirmation, lower gas limit
// Big blocks: ~1 minute confirmation, higher gas limit
export const SMALL_BLOCK_GAS_LIMIT = 2_000_000n
export const BIG_BLOCK_GAS_LIMIT = 30_000_000n

// Swap gas estimation constants
export const BASE_COMPUTATION_UNITS = 310000
export const GAS_BUFFER = 1.4

/**
 * Details about a gas limit exceeded situation
 */
export interface GasLimitExceededDetails {
  /** The estimated gas required for the transaction */
  estimatedGas: bigint
  /** The current block gas limit */
  limit: bigint
  /** Estimated gas units for the transaction */
  computationUnits: number
}

/**
 * Steps in the big blocks + swap flow
 */
export type BigBlocksFlowStep = 'approve-agent' | 'enable-big-blocks' | 'revoke-agent' | 'execute-swap' | 'switch-back'

/**
 * Status for each step in the flow
 */
export type StepStatus = 'pending' | 'in-progress' | 'complete' | 'error'
